export const IMAGES = {
  logo: "https://irp.cdn-website.com/f1256bd8/dms3rep/multi/opt/cropped-90399555_1279256432264216_2645891276733415424_n-1-1536x1536-1920w.jpg",
  brand: "https://irp.cdn-website.com/f1256bd8/dms3rep/multi/opt/TLTA-a184c8be-1920w.png",
  building: "https://lirp.cdn-website.com/f1256bd8/dms3rep/multi/opt/small_outside_The-Learning-Tree-Academy_7412+copy-1920w.jpg",
  necpa: "https://irp.cdn-website.com/f1256bd8/dms3rep/multi/opt/NECPA_LOGO_HEADER-261w.png",
  toddler: "https://irp.cdn-website.com/f1256bd8/dms3rep/multi/opt/74588703_2492138657535540_3581511187331809280_n-1920w.jpg",
  preschool: "https://irp.cdn-website.com/f1256bd8/dms3rep/multi/opt/80047999_2579278548821550_4470859740213149696_n-1920w.jpg",
  mixedAge: "https://irp.cdn-website.com/f1256bd8/dms3rep/multi/opt/79824150_2587270678022337_8031375804552183808_n-1920w.jpg",
  transition: "https://irp.cdn-website.com/f1256bd8/dms3rep/multi/opt/79224700_2576410649108340_8611589190041206784_n-1920w.jpg",
  vpkBanner: "https://irp.cdn-website.com/f1256bd8/dms3rep/multi/opt/The+Learning+Tree+%281%29-1920w.png",
  funshine: "https://irp.cdn-website.com/f1256bd8/dms3rep/multi/opt/Digital-Page-Logo-c34507ba-1920w.png",
  classroomStock: "https://images.unsplash.com/photo-1509062522246-3755977927d7?q=80&w=1600&auto=format&fit=crop",
  healthyFood: "https://images.unsplash.com/photo-1540420773420-3366772f4999?q=80&w=1600&auto=format&fit=crop",
};

export const SITE = {
  name: "The Learning Tree Academy",
  city: "Palm Bay, FL",
  phoneDisplay: "(321) 951-3868",
  phoneHref: "tel:+13219513868",
  whatsapp: "https://wa.me/13219513868?text=Hi!%20I%27d%20like%20to%20learn%20more%20about%20The%20Learning%20Tree%20Academy.",
  email: "learningtreepalmbay@gmail.com",
  address: "207 Emerson Drive NW, Palm Bay, FL 32907",
  hours: "Mon–Fri · 6:30 AM – 6:00 PM",
  facebook: "https://facebook.com/thelearningtreeofpalmbay",
  instagram: "https://instagram.com/thelearningtreeofpalmbay/",
  mapEmbed: "https://maps.google.com/maps?q=207%20Emerson%20Drive%20NW%2C%20Palm%20Bay%2C%20FL%2032907&t=&z=14&ie=UTF8&iwloc=&output=embed",
};

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTENT = {
  en: {
    facts: [
      { icon: "Baby", title: "Ages 1 – 12", desc: "Infants, Toddlers, VPK & After-School" },
      { icon: "Clock", title: "6:30 AM – 6:00 PM", desc: "Flexible hours for working parents" },
      { icon: "UtensilsCrossed", title: "3 Free USDA Meals", desc: "Breakfast, hot lunch & afternoon snack" },
      { icon: "Award", title: "NECPA Gold Seal", desc: "Florida's highest early-learning standard" },
    ],
    chapters: [
      {
        num: "01",
        title: "Accredited, licensed & trusted for 30+ years",
        body: "NECPA-accredited and Gold Seal designated. Licensed by the Department of Children and Families, recognized by the Early Learning Coalition of Brevard, and a high-performing VPK provider on the Florida Kindergarten Readiness Screener.",
        icon: "ShieldCheck",
      },
      {
        num: "02",
        title: "Children learn by doing",
        body: "Our FunShine Digital® curriculum is built on a simple truth: children learn through play, experimentation and exploration. Dynamic investigation, open-ended experiences, and teachers who facilitate rather than lecture.",
        icon: "Blocks",
      },
      {
        num: "03",
        title: "Fuel for growing minds",
        body: "Ninety percent of brain growth happens before age five — so we serve three free USDA-approved meals every day. Hot breakfast, balanced lunch, afternoon snack. No lunchbox required.",
        icon: "Apple",
      },
      {
        num: "04",
        title: "An open door for parents",
        body: "We welcome parents to visit and volunteer any time. Lesson plans and daily schedules are posted in every classroom, and teachers are always a conversation away.",
        icon: "DoorOpen",
      },
    ],
    programs: [
      {
        id: "infants",
        testId: "program-card-infants",
        title: "Infants & Toddlers",
        age: "Ages 1 – 2",
        image: IMAGES.toddler,
        short: "Nurturing sensory play, loving routines, and gentle milestones on your child's own daily schedule.",
        body: "We keep your child on his or her daily schedule as much as possible. Through the day we do activities that develop social, emotional, cognitive, language and physical skills — playing with toys, art, pretending, stories and books, discovering sand and water, music, and exploring outdoors.",
        tags: ["Low ratios", "Sensory play", "Daily reports"],
      },
      {
        id: "preschool",
        testId: "program-card-vpk",
        title: "Pre-School & Free VPK",
        age: "Ages 3 – 5",
        image: IMAGES.preschool,
        short: "Structured literacy, early math, science, music and art — a VPK program that exceeds Florida kindergarten expectations.",
        body: "Movement & coordination, autonomy & social skills, language and nursery rhymes, early mathematics, orientation in time and space, science, music and visual arts — our preschool curriculum covers the whole child, guided by the FunShine Digital® lesson plans posted in every room.",
        tags: ["Free Florida VPK", "Phonics & early math", "Kindergarten readiness"],
      },
      {
        id: "mixed-age",
        testId: "program-card-mixed-age",
        title: "Mixed-Age Grouping",
        age: "Ages 2 – 5",
        image: IMAGES.mixedAge,
        short: "Older children grow patient and confident; younger ones leap forward — a rich environment that honors every pace.",
        body: "At set times of day, children at least one year apart share a classroom, guided by staff educated in mixed-age practice. Older children learn to be helpful, patient and tolerant. Younger children absorb advanced cognitive and social skills. Every child is challenged to think more creatively and flexibly.",
        tags: ["Peer mentorship", "Confidence building", "Individual pace"],
      },
      {
        id: "summer-camp",
        testId: "program-card-summer-camp",
        title: "Transition & Summer Camp",
        age: "Ages 4 – 12",
        image: IMAGES.transition,
        short: "Individual transition plans for every child, plus a theme-packed summer camp and FREE Summer VPK.",
        body: "Every child moving classrooms gets an individualized Transition Plan so new teachers, friends and routines feel familiar before day one. In summer, weekly-themed camp brings art projects, music, water fun, sports, cooking, theatre and field trips for ages 4–12 — with free Summer VPK for eligible 4-year-olds.",
        tags: ["Free Summer VPK", "Weekly themes", "Field trips"],
      },
    ],
    testimonials: [
      {
        author: "Lucian R.",
        role: "Palm Bay parent",
        quote: "This is a very nice preschool with great staff. Hudson loves going to school — he is always so happy to go see Miss Vonda and the others. The facility is clean and the staff is very friendly. Hudson has learned lots of new skills, and the teachers say he integrated right away as if he'd been going for months. We are thankful they are so close to home!",
      },
      {
        author: "Jaime V.",
        role: "Palm Bay parent",
        quote: "Before we moved from Broward, some professionals were telling me my daughter had milestone delays — she wasn't talking and didn't know how to express her feelings. I put her in The Learning Tree and my daughter is a new kid: she is talking, trying new foods, doing new and different things, expressing herself better. I absolutely love this school and would recommend it 10 million percent. Ms. Joan and her team are caring, loving, supportive and passionate — all about the kids and their growth, period.",
      },
      {
        author: "Kathie M.",
        role: "Palm Bay parent",
        quote: "This daycare is exceptional. Miss Joan and her staff provide so much more than other facilities. I have watched my child grow socially, academically, and develop so many skills at the center. They meet each child wherever they are and work with them to reach their full potential — a safe, healthy and stable environment for children and their families. I cannot say enough about The Learning Tree and the caregiver team they have.",
      },
    ],
    marquee: [
      "Gold Seal Accredited",
      "Free Florida VPK",
      "3 USDA Meals Daily",
      "Ages 1 – 12",
      "Open 6:30 AM – 6:00 PM",
      "Palm Bay's Premier Preschool",
    ],
    programsMarquee: ["Full & Part-Time Contracts", "FunShine Digital® Curriculum", "Before & After School Care", "Free Summer VPK"],
    portalHighlights: [
      { icon: "NotebookPen", title: "Daily digital reports", desc: "Meals, naps, diapers and learning moments — logged and shared every day." },
      { icon: "Camera", title: "Secure photo updates", desc: "See the finger-painting masterpiece before pickup, not after." },
      { icon: "MessageSquareHeart", title: "Direct teacher messaging", desc: "Questions at 10 AM, answers by snack time. No phone tag." },
      { icon: "Siren", title: "Emergency reach-outs", desc: "Urgent updates reach you instantly, wherever your day takes you." },
    ],
  },
  es: {
    facts: [
      { icon: "Baby", title: "Edades 1 – 12", desc: "Bebés, niños pequeños, VPK y después de clases" },
      { icon: "Clock", title: "6:30 AM – 6:00 PM", desc: "Horario flexible para padres que trabajan" },
      { icon: "UtensilsCrossed", title: "3 Comidas USDA Gratis", desc: "Desayuno, almuerzo caliente y merienda" },
      { icon: "Award", title: "NECPA Gold Seal", desc: "El más alto estándar de Florida" },
    ],
    chapters: [
      {
        num: "01",
        title: "Acreditados, licenciados y confiables por más de 30 años",
        body: "Acreditados por NECPA con designación Gold Seal. Licenciados por el Departamento de Niños y Familias, reconocidos por la Early Learning Coalition de Brevard y proveedores VPK de alto rendimiento en el Florida Kindergarten Readiness Screener.",
        icon: "ShieldCheck",
      },
      {
        num: "02",
        title: "Los niños aprenden haciendo",
        body: "Nuestro currículo FunShine Digital® se basa en una verdad simple: los niños aprenden jugando, experimentando y explorando. Investigación dinámica, experiencias abiertas y maestras que facilitan en lugar de dar discursos.",
        icon: "Blocks",
      },
      {
        num: "03",
        title: "Combustible para mentes en crecimiento",
        body: "El noventa por ciento del desarrollo cerebral ocurre antes de los cinco años — por eso servimos tres comidas aprobadas por el USDA gratis cada día. Desayuno caliente, almuerzo balanceado y merienda. No necesitas lonchera.",
        icon: "Apple",
      },
      {
        num: "04",
        title: "Puertas abiertas para los padres",
        body: "Los padres son bienvenidos a visitar y ser voluntarios en cualquier momento. Los planes de lección y horarios diarios están publicados en cada salón, y las maestras siempre están a una conversación de distancia.",
        icon: "DoorOpen",
      },
    ],
    programs: [
      {
        id: "infants",
        testId: "program-card-infants",
        title: "Bebés y Niños Pequeños",
        age: "Edades 1 – 2",
        image: IMAGES.toddler,
        short: "Juego sensorial con cariño, rutinas amorosas y logros suaves siguiendo el horario diario de tu hijo.",
        body: "Mantenemos a tu hijo en su horario diario tanto como sea posible. Durante el día hacemos actividades que desarrollan habilidades sociales, emocionales, cognitivas, de lenguaje y físicas — jugar con juguetes, arte, juegos de imaginación, cuentos y libros, descubrir arena y agua, música y exploración al aire libre.",
        tags: ["Ratios bajos", "Juego sensorial", "Reportes diarios"],
      },
      {
        id: "preschool",
        testId: "program-card-vpk",
        title: "Preescolar y VPK Gratis",
        age: "Edades 3 – 5",
        image: IMAGES.preschool,
        short: "Lectoescritura estructurada, matemáticas tempranas, ciencia, música y arte — un programa VPK que supera las expectativas de kindergarten de Florida.",
        body: "Movimiento y coordinación, autonomía y habilidades sociales, lenguaje y rimas infantiles, matemáticas tempranas, orientación en tiempo y espacio, ciencia, música y artes visuales — nuestro currículo preescolar cubre al niño completo, guiado por los planes FunShine Digital® publicados en cada salón.",
        tags: ["VPK Gratis de Florida", "Fonética y matemáticas", "Preparación para kindergarten"],
      },
      {
        id: "mixed-age",
        testId: "program-card-mixed-age",
        title: "Agrupación de Edades Mixtas",
        age: "Edades 2 – 5",
        image: IMAGES.mixedAge,
        short: "Los mayores se vuelven pacientes y seguros; los pequeños avanzan a pasos agigantados — un ambiente rico que honra cada ritmo.",
        body: "En ciertos momentos del día, niños con al menos un año de diferencia comparten el salón, guiados por personal capacitado en la práctica de edades mixtas. Los mayores aprenden a ser serviciales, pacientes y tolerantes. Los pequeños absorben habilidades cognitivas y sociales avanzadas. Cada niño es desafiado a pensar con más creatividad y flexibilidad.",
        tags: ["Mentoría entre compañeros", "Confianza", "Ritmo individual"],
      },
      {
        id: "summer-camp",
        testId: "program-card-summer-camp",
        title: "Transición y Campamento de Verano",
        age: "Edades 4 – 12",
        image: IMAGES.transition,
        short: "Planes de transición individuales para cada niño, además de un campamento de verano lleno de temas y VPK de Verano GRATIS.",
        body: "Cada niño que cambia de salón recibe un Plan de Transición individualizado para que las nuevas maestras, amigos y rutinas se sientan familiares antes del primer día. En verano, el campamento con temas semanales trae proyectos de arte, música, juegos de agua, deportes, cocina, teatro y excursiones para edades 4–12 — con VPK de Verano gratis para niños elegibles de 4 años.",
        tags: ["VPK de Verano Gratis", "Temas semanales", "Excursiones"],
      },
    ],
    testimonials: [
      {
        author: "Lucian R.",
        role: "Familia de Palm Bay",
        quote: "Este es un preescolar muy bonito con un personal excelente. Hudson ama ir a la escuela — siempre está feliz de ver a Miss Vonda y a los demás. Las instalaciones están limpias y el personal es muy amable. Hudson ha aprendido muchas habilidades nuevas, y las maestras dicen que se integró de inmediato, ¡como si llevara meses asistiendo! ¡Estamos agradecidos de que estén tan cerca de casa!",
      },
      {
        author: "Jaime V.",
        role: "Familia de Palm Bay",
        quote: "Antes de mudarnos desde Broward, algunos profesionales me decían que mi hija tenía retrasos en su desarrollo — no hablaba y no sabía expresar sus sentimientos. La inscribí en The Learning Tree y mi hija es una niña nueva: habla, prueba comidas nuevas, hace cosas nuevas y diferentes, se expresa mejor. Amo esta escuela y la recomendaría diez millones por ciento. Ms. Joan y su equipo son cariñosos, atentos y apasionados — todo por los niños y su crecimiento, punto.",
      },
      {
        author: "Kathie M.",
        role: "Familia de Palm Bay",
        quote: "Esta guardería es excepcional. Miss Joan y su personal ofrecen mucho más que otras instalaciones. He visto a mi hijo crecer social y académicamente, y desarrollar tantas habilidades en el centro. Atienden a cada niño donde está y lo ayudan a alcanzar su máximo potencial — un ambiente seguro, saludable y estable para los niños y sus familias. No puedo decir suficiente sobre The Learning Tree y su equipo de cuidadores.",
      },
    ],
    marquee: [
      "Acreditados Gold Seal",
      "VPK Gratis de Florida",
      "3 Comidas USDA al Día",
      "Edades 1 – 12",
      "Abierto 6:30 AM – 6:00 PM",
      "El Preescolar Preferido de Palm Bay",
    ],
    programsMarquee: ["Contratos de Tiempo Completo y Parcial", "Currículo FunShine Digital®", "Cuidado Antes y Después de Clases", "VPK de Verano Gratis"],
    portalHighlights: [
      { icon: "NotebookPen", title: "Reportes digitales diarios", desc: "Comidas, siestas, pañales y momentos de aprendizaje — registrados y compartidos cada día." },
      { icon: "Camera", title: "Fotos seguras", desc: "Mira la obra maestra de pintura de dedos antes de la recogida, no después." },
      { icon: "MessageSquareHeart", title: "Mensajes directos con la maestra", desc: "Preguntas a las 10 AM, respuestas antes de la merienda. Sin persecuciones telefónicas." },
      { icon: "Siren", title: "Avisos de emergencia", desc: "Las actualizaciones urgentes te llegan al instante, dondequiera que estés." },
    ],
  },
};
